// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container__2hSwS","image":"quote_image__1ajUI","textDiv":"quote_textDiv__3nBq3"};